import {UserAccessCategory} from "./user.access.category";

export const createAccessCategoryMap = (accessCategories: UserAccessCategory[]): {[id: string]: string} => {
    const result: {[id: string]: string} = {};
    accessCategories.forEach(({id, name}) => {
        result[id] = name;
    })
    return result;
}
